import { createAction } from 'redux-actions';
import { UPDATE_USER_INIT } from '../actionTypes';

const updateUserInit = createAction(UPDATE_USER_INIT);

export { updateUserInit };
